import '@/core/i18n/i18n';
import { AppProvider } from '@/core/providers';

function App() {
  return <AppProvider />;
}

export default App;
